import { z } from "zod";
import { dateTimeIsoStringSchema } from "../utils/date";
import { zTimeString } from "../utils/string.schema";
import type { ZodSchemaWithInputMatchingOutput } from "../zodUtils";
import type {
  DailyScheduleDto,
  ScheduleDto,
  SelectedDaysOfTheWeekDto,
  TimePeriodDto,
  TimePeriodsDto,
  WeekdayNumber,
} from "./Schedule.dto";

// Time period within a day.
// TODO We could refine by checking that start < end
export const timePeriodSchema: ZodSchemaWithInputMatchingOutput<TimePeriodDto> =
  z.object({
    start: zTimeString,
    end: zTimeString,
  });

export const timePeriodsSchema: ZodSchemaWithInputMatchingOutput<TimePeriodsDto> =
  z.array(timePeriodSchema);

export const dailyScheduleSchema: ZodSchemaWithInputMatchingOutput<DailyScheduleDto> =
  z.object({
    date: dateTimeIsoStringSchema,
    timePeriods: timePeriodsSchema,
  });

export const immersionDaysScheduleSchema: ZodSchemaWithInputMatchingOutput<
  DailyScheduleDto[]
> = z.array(dailyScheduleSchema);

export const weekDaySchema = z
  .number()
  .int()
  .min(0)
  .max(6) as ZodSchemaWithInputMatchingOutput<WeekdayNumber>;

// Each tuple represents a weekday range, e.g.:
// [0, 4] means "Monday to Friday, inclusive"
// [0, 0] means "Monday"
export const selectedDaysOfTheWeekSchema: ZodSchemaWithInputMatchingOutput<SelectedDaysOfTheWeekDto> =
  z.array(weekDaySchema);

export const scheduleSchema: ZodSchemaWithInputMatchingOutput<ScheduleDto> =
  z.object({
    totalHours: z.number(),
    workedDays: z.number(),
    isSimple: z.boolean(),
    complexSchedule: immersionDaysScheduleSchema,
  });
